/**
 * Source for Browser ID info
 * @module
 */

var UAParser = require('core/utils/ua_parser');

/**
 * Gets the browser name
 * @return {string}
 */
exports.getId = function(): string {
  return UAParser.get().browser.id;
};

/**
 * @return {string}
 */
exports.getVersion = function(): string {
  return UAParser.get().browser.version;
};
